import React, { useContext } from 'react';
// import { FaArrowRightLong, FaArrowLeftLong } from 'react-icons/fa6';
import { FormContext } from './Provider'; // 
import { useNavigate } from 'react-router-dom';


export default function EmploymentInfo({ step, setStep }) {

  console.log("step:", step, "setStep:", setStep); // Debug line
  const navigate = useNavigate()
  const { employmentData, setemploymentData } = useContext(FormContext);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setemploymentData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    console.log('Submit', employmentData);
  };
  const handleNextClick = () => {
    console.log("Next clicked. Employment Data:", employmentData);

    navigate('/admission-form');
    setStep(step + 1)

    // setemploymentData({
    //   company: "",
    //   designation: "",
    //   experience: "",
    //   location: "",
    //   joineddate: "",
    //   enddate: "",
    //   currentlyWorking: false,
    // });
  };

  return (
    // <section className="bg-white  p-7">
    //   <div className=" bg-gray-100 px-4  container py-5 h-100 flex justify-center items-start">
    //     <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-4xl">
    //       <div className="font-bold text-lg text-primary-800">Employement Details</div>
    //       <div className="pt-2 text-gray-700">Please provide your Employement information</div>

    //       <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">


    //         <div className="relative w-full">
    //           <input
    //             type="text"
    //             name="company"
    //             id="company"
    //             placeholder=" "
    //             value={employmentData.company}
    //             onChange={handleChange}
    //             className="peer h-14 w-full px-4 pt-6 pb-2 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    //           />
    //           <label
    //             htmlFor="company"
    //             className="absolute left-4 px-1 bg-white  sm:text-base text-gray-500 transition-all duration-300 transform top-1/2 -translate-y-[2.6rem] scale-75 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-1/2 peer-focus:-translate-y-[2.6rem] peer-focus:scale-75 peer-focus:text-blue-600"
    //           >
    //             Company Name
    //           </label>
    //         </div>


    //         <div className="relative w-full">
    //           <input
    //             type="text"
    //             id="designation"
    //             name="designation"
    //             placeholder=" "
    //             value={employmentData.designation}
    //             onChange={handleChange}
    //             className="peer h-14 w-full px-4 pt-6 pb-2 text-lg text-gray-900 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    //           />
    //           <label
    //             htmlFor="designation"
    //             className="absolute left-4 px-1 bg-white text-lg sm:text-base text-gray-500 transition-all duration-300 transform top-1/2 -translate-y-[2.6rem] scale-75 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-1/2 peer-focus:-translate-y-[2.6rem] peer-focus:scale-75 peer-focus:text-blue-600"
    //           >
    //             Designation
    //           </label>
    //         </div>


    //         <div className="relative w-full">
    //           <input
    //             type="number"
    //             name="experience"
    //             id="experience"
    //             placeholder=" "
    //             value={employmentData.experience}
    //             onChange={handleChange}
    //             className="peer h-14 w-full px-4 pt-6 pb-2 text-sm  text-gray-900 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    //           />
    //           <label
    //             htmlFor="experience"
    //             className="absolute left-4 px-1 bg-white text-lg sm:text-base text-gray-500 transition-all duration-300 transform top-1/2 -translate-y-[2.6rem] scale-75 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-1/2 peer-focus:-translate-y-[2.6rem] peer-focus:scale-75 peer-focus:text-blue-600"
    //           >
    //             Years Of Experience
    //           </label>
    //         </div>


    //         <div className="relative w-full">
    //           <input
    //             type="text"
    //             name="location"
    //             id="location"
    //             placeholder=" "
    //             value={employmentData.location}
    //             onChange={handleChange}
    //             className="peer h-14 w-full px-4 pt-6 pb-2 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    //           />
    //           <label
    //             htmlFor="location"
    //             className="absolute left-4 px-1 bg-white text-lg sm:text-base text-gray-500 transition-all duration-300 transform top-1/2 -translate-y-[2.6rem] scale-75 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-1/2 peer-focus:-translate-y-[2.6rem] peer-focus:scale-75 peer-focus:text-blue-600"
    //           >
    //             Location
    //           </label>
    //         </div>


    //         <div className="relative w-full">
    //           <input
    //             type="date"
    //             id="joineddate"
    //             name="joineddate"
    //             value={employmentData.joineddate}
    //             onChange={handleChange}
    //             className="h-14 w-full px-4 py-2 peer rounded-lg text-sm text-gray-900 bg-gray-50 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-600"
    //           />
    //           <label
    //             htmlFor="joineddate"
    //             className="absolute top-0 left-4 -translate-y-1/2 px-1 bg-gray-50 text-sm sm:text-sm text-gray-500"
    //           >
    //             Joined Date
    //           </label>
    //         </div>


    //         <div className="relative w-full">
    //           <input
    //             type="date"
    //             id="enddate"
    //             name='enddate'
    //             value={employmentData.enddate}
    //             onChange={handleChange}
    //             className="h-14 w-full px-4 py-2 peer rounded-lg text-sm text-gray-900 bg-gray-50 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-600"
    //           />
    //           <label
    //             htmlFor="enddate"
    //             className="absolute top-0 left-4 -translate-y-1/2 px-1 bg-gray-50 text-sm sm:text-sm text-gray-500"
    //           >
    //             End Date
    //           </label>
    //         </div>


    //         <div className="col-span-1 md:col-span-2 flex items-center mt-2">
    //           <input
    //             type="checkbox"
    //             id="currentlyWorking"
    //             name="currentlyWorking"
    //             checked={employmentData.currentlyWorking}
    //             onChange={handleChange}
    //             className="mr-2 w-5 h-5 text-blue-600 rounded border-gray-300 focus:ring-2 focus:ring-blue-500"
    //           />
    //           <label htmlFor="currentlyWorking" className="text-gray-700 text-sm">
    //             Currently Working
    //           </label>
    //         </div>


    //         <div className="col-span-1 md:col-span-2 flex flex-row sm:flex-row justify-between mt-6 gap-4">
    //           <button
    //             type="button"
    //             className="w-full sm:w-auto py-2 px-4 rounded-md text-white text-base font-medium bg-primary-800 hover:bg-primary-700 flex items-center justify-center gap-2"
    //             onClick={() => {
    //               navigate('/admission-form')
    //               setStep(step - 1)
    //             }}>

    //             Back
    //           </button>
    //           <button
    //             type="button"
    //             onClick={handleNextClick}
    //             className="w-full sm:w-auto py-2 px-4 rounded-md text-white text-base font-medium bg-primary-800 hover:bg-primary-700 flex items-center justify-center gap-2"
    //           >
    //             Next

    //           </button>
    //         </div>
    //       </form>
    //     </div>
    //   </div>
    // </section>




    <section className="bg-white p-7">
      <div className="bg-gray-100 px-4 container py-5 h-100 flex justify-center items-start">
        <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-4xl">
          <div className="font-bold text-lg text-primary-800">Employment Details</div>
          <div className="pt-2 text-gray-700">Please provide your employment information</div>

          <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">

            {/* Checkbox */}
            <div className="col-span-1 md:col-span-2 flex items-center mt-2">
              <input
                type="checkbox"
                id="currentlyWorking"
                name="currentlyWorking"
                checked={employmentData.currentlyWorking}
                onChange={handleChange}
                className="mr-2 w-5 h-5 text-blue-600 rounded border-gray-300 focus:ring-2 focus:ring-blue-500"
              />
              <label htmlFor="currentlyWorking" className="text-gray-700 text-base font-medium">
                Are you currently employed?
              </label>
            </div>

            {/* Company Name */}
            <div className="relative w-full">
              <input
                type="text"
                name="company"
                id="company"
                placeholder=" "
                value={employmentData.company}
                onChange={handleChange}
                disabled={!employmentData.currentlyWorking}
                className="peer h-14 w-full px-4 pt-6 pb-2 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
              />
              <label
                htmlFor="company"
                className="absolute left-4 px-1 bg-white text-base font-medium text-gray-400 transition-all duration-300 transform top-1/2 -translate-y-[2.6rem] scale-75 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-1/2 peer-focus:-translate-y-[2.6rem] peer-focus:scale-75 peer-focus:text-blue-600"
              >
                Company Name
              </label>
            </div>

            {/* Designation */}
            <div className="relative w-full">
              <input
                type="text"
                id="designation"
                name="designation"
                placeholder=" "
                value={employmentData.designation}
                onChange={handleChange}
                disabled={!employmentData.currentlyWorking}
                className="peer h-14 w-full px-4 pt-6 pb-2 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
              />
              <label
                htmlFor="designation"
                className="absolute left-4 px-1 bg-white text-base font-medium text-gray-400 transition-all duration-300 transform top-1/2 -translate-y-[2.6rem] scale-75 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-1/2 peer-focus:-translate-y-[2.6rem] peer-focus:scale-75 peer-focus:text-blue-600"
              >
                Designation
              </label>
            </div>

            {/* Experience */}
            <div className="relative w-full">
              <input
                type="number"
                name="experience"
                id="experience"
                placeholder=" "
                value={employmentData.experience}
                onChange={handleChange}
                disabled={!employmentData.currentlyWorking}
                className="peer h-14 w-full px-4 pt-6 pb-2 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
              />
              <label
                htmlFor="experience"
                className="absolute left-4 px-1 bg-white text-base font-medium text-gray-400 transition-all duration-300 transform top-1/2 -translate-y-[2.6rem] scale-75 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-1/2 peer-focus:-translate-y-[2.6rem] peer-focus:scale-75 peer-focus:text-blue-600"
              >
                Years Of Experience
              </label>
            </div>

            {/* Location */}
            <div className="relative w-full">
              <input
                type="text"
                name="location"
                id="location"
                placeholder=" "
                value={employmentData.location}
                onChange={handleChange}
                disabled={!employmentData.currentlyWorking}
                className="peer h-14 w-full px-4 pt-6 pb-2 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
              />
              <label
                htmlFor="location"
                className="absolute left-4 px-1 bg-white text-base font-medium text-gray-400 transition-all duration-300 transform top-1/2 -translate-y-[2.6rem] scale-75 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-1/2 peer-focus:-translate-y-[2.6rem] peer-focus:scale-75 peer-focus:text-blue-600"
              >
                Location
              </label>
            </div>

            {/* Joined Date */}
            <div className="relative w-full">
              <input
                type="date"
                id="joineddate"
                name="joineddate"
                value={employmentData.joineddate}
                onChange={handleChange}
                disabled={!employmentData.currentlyWorking}
                className="h-14 w-full px-4 py-2 peer rounded-lg text-sm text-gray-900 bg-gray-50 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-600 disabled:bg-gray-100 disabled:cursor-not-allowed"
              />
              <label
                htmlFor="joineddate"
                className="absolute top-0 left-4 -translate-y-1/2 px-1 bg-gray-50   text-gray-400 text-sm font-medium"
              >
                Joined Date
              </label>
            </div>

            {/* End Date */}
            <div className="relative w-full">
              <input
                type="date"
                id="enddate"
                name="enddate"
                value={employmentData.enddate}
                onChange={handleChange}
                disabled={!employmentData.currentlyWorking} // disables if currently working
                className="h-14 w-full px-4 py-2 peer rounded-lg text-sm text-gray-900 bg-gray-50 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-600 disabled:bg-gray-100 disabled:cursor-not-allowed"
              />
              <label
                htmlFor="enddate"
                className="absolute top-0 left-4 -translate-y-1/2 px-1 bg-gray-50  text-gray-400 text-sm font-medium"
              >
                End Date
              </label>
            </div>

            {/* Buttons */}
            <div className="col-span-1 md:col-span-2 flex flex-row sm:flex-row justify-between mt-6 gap-4">
              <button
                type="button"
                className="w-full sm:w-auto py-2 px-4 rounded-md text-white text-base font-medium bg-primary-800 hover:bg-primary-700 flex items-center justify-center gap-2"
                onClick={() => {
                  navigate('/admission-form');
                  setStep(step - 1);
                }}
              >
                Back
              </button>

              <button
                type="button"
                onClick={employmentData.currentlyWorking ? handleNextClick : () => setStep(step + 1)}
                className="w-full sm:w-auto py-2 px-4 rounded-md text-white text-base font-medium bg-primary-800 hover:bg-primary-700 flex items-center justify-center gap-2"
              >
                {employmentData.currentlyWorking ? 'Next' : 'Skip'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>

  );
}